import { useEffect, useState } from "react";
import { getScheduleLimits, splitLocalDateTime, type DateTimeParts, type ScheduleLimits } from "../services/scheduleLimits";

export type ScheduleWindow = {
  limits: ScheduleLimits | null;
  /** Primeiro início permitido; `null` quando não há restrição (ADMIN/SUPPORT ou limites indisponíveis). */
  earliest: DateTimeParts | null;
  /** Último início oferecido para um agendamento avulso; `null` quando não há restrição. */
  latest: DateTimeParts | null;
};

/** Janela de início permitida para o clube do `deviceId`, vinda do servidor (fuso do clube). */
export function useScheduleLimits(deviceId?: number | null): ScheduleWindow {
  const [limits, setLimits] = useState<ScheduleLimits | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLimits(null);
    if (!deviceId) return undefined;
    void getScheduleLimits(deviceId).then((result) => {
      if (!cancelled) setLimits(result);
    });
    return () => {
      cancelled = true;
    };
  }, [deviceId]);

  const enforced = limits?.enforced === true;
  return {
    limits,
    earliest: enforced ? splitLocalDateTime(limits?.earliestStart) : null,
    latest: enforced ? splitLocalDateTime(limits?.latestStart) : null,
  };
}

/** Só aplica `minTime`/`maxTime` no dia em que o limite cai; nos demais dias o horário é livre. */
export const timeBoundFor = (date: string, bound: DateTimeParts | null): string | undefined =>
  bound && date === bound.date ? bound.time : undefined;

/** `2026-10-27` + `16:15` → `27/10/2026 16:15`. */
export const formatDateTimeParts = ({ date, time }: DateTimeParts): string =>
  `${date.split("-").reverse().join("/")} ${time}`;
